import { render } from "./EditEventPopup.vue?vue&type=template&id=39c9a329&ts=true"
import script from "./EditEventPopup.vue?vue&type=script&lang=ts"
export * from "./EditEventPopup.vue?vue&type=script&lang=ts"

import "./EditEventPopup.vue?vue&type=style&index=0&id=39c9a329&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__